export default __webpack_public_path__ + "static/media/volunteer3.a9ef2982.png";